enum ClaimRoutes {
  BANK_ACCOUNT = '/claim/bankAccount',

  PAYMENT_METHOD = '/claim/:fulfillmentId/payment-method',
  PRIMER = '/claim/:fulfillmentId/primer',

  ACH_ACCOUNT_NUMBER = '/claim/:fulfillmentId/ach/account-number',
  ACH_ACCOUNT_TYPE = '/claim/:fulfillmentId/ach/account-type',
  ACH_ROUTING_NUMBER = '/claim/:fulfillmentId/ach/routing-number',

  MAILING_ADDRESS = '/claim/:fulfillmentId/mailing-address',

  ZELLE_PRIMER = '/claim/:fulfillmentId/zelle/primer',
  ZELLE_EMAIL_CONFIRMATION = '/claim/:fulfillmentId/zelle/email-confirmation',

  REVIEW = '/claim/:fulfillmentId/review',
  SUBMISSION = '/claim/:fulfillmentId/submission',

  W9_TAX_FORM = '/claim/:fulfillmentId/w9',

  ERROR = '/claim/:fulfillmentId/error',
}
export default ClaimRoutes;
